import { Injectable } from '@angular/core';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import { FilterItems } from '../../components/filters/filter.interface';
import {
  EligibilityRoutingFilters,
  IEligibilityRouting,
} from '../../interfaces/eligibility-routing/eligibility-routing.interface';
import { CommonGraphqlService } from '../common.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class EligibilityRoutingStateService extends GridController<EligibilityRoutingFilters> {
  private _eligibilityRoutings: IEligibilityRouting[];

  private _filter: EligibilityRoutingFilters = {
    scId: '',
    groupId: '',
    processorId: '',
    ediId: '',
    payerName: '',
    removeSubscriberAddress: '',
    removeSubscriberGender: '',
    removeRefSy: '',
    removeReceiverRef0b: '',
    removeSubscriberNm1Mi: '',
    removeSubscriberDtp102: '',
    removeReceiverRefTj: '',
    removePrv: '',
    changeReceiverNonPersonEntity: '',
    recordStatus: '',
    ediIdQualifier: '',
  };

  ClaimStatusRoutingFilters: FilterItems = {
    filtersName: 'EligibilityRouting',
    items: [
      {
        name: 'payerName',
        caption: 'payer name',
        type: 'text',
        placeholder: 'Enter Payer Name',
      },
      {
        caption: 'SC ID',
        name: 'scId',
        type: 'text',
        placeholder: 'Enter SC ID',
      },
      {
        caption: 'Processor Id',
        name: 'processorId',
        type: 'text',
        placeholder: 'Enter Processor ID',
      },
      {
        caption: 'group ID',
        name: 'groupId',
        type: 'text',
        placeholder: 'Enter group ID',
      },
      {
        caption: 'edi ID',
        name: 'ediId',
        type: 'text',
        placeholder: 'Enter EDI ID',
      },
      {
        name: 'recordStatus',
        type: 'checkbox',
        values: [{ text: 'Show Inactive Only', value: 'I' }],
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    ediId: '',
    groupId: '',
    payerName: 'ASC',
    processorId: '',
    removeReceiverRef0b: '',
    removeReceiverRefTj: '',
    removeRefSy: '',
    removeSubscriberAddress: '',
    removeSubscriberDtp102: '',
    removeSubscriberGender: '',
    removeSubscriberNm1Mi: '',
    scId: '',
  };

  constructor(private commonGraphqlService: CommonGraphqlService) {
    super();
    this.init(this._filter, 1, 'name');
  }

  get payers(): IEligibilityRouting[] {
    return this._eligibilityRoutings;
  }

  set payers(value: IEligibilityRouting[]) {
    this._eligibilityRoutings = value;
  }

  // getStates():Observable<DropDownItem[]>{
  //   return this.commonGraphqlService.getStates();
  // }
}
